import logo from "./logo.svg";
import "./App.css";
import "./assets/fonts/ViceCitySans.otf";
import "./assets/styles/ourwork.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Dashboard,
  ConnectWithUs,
  OurWork,
  SinglePost,
  AboutUs,
  Hiring,
  News,
  InvestorLogin,
  BusinessLogin,
  Services,
} from "./components/pages";
import InvestorDashboard from "./components/pages/privateDashboard/investorDashboard";
import RevenueBusiness from "./components/pages/privateDashboard/investorDashboard/revenueBusiness";
import TotalBusiness from "./components/pages/privateDashboard/investorDashboard/totalBusiness";
import ValueBusiness from "./components/pages/privateDashboard/investorDashboard/valueBusiness";
import Report from "./components/pages/privateDashboard/report";
import OurBusiness from "./components/pages/privateDashboard/ourBusiness";
import PageNotFound from "./components/pages/notFound";
import ForbiddenPage from "./components/pages/forbiddenPages";
import BusinessDashboard from "./components/pages/privateDashboard/businessDashboard";
import ListBusiness from "./components/pages/privateDashboard/businessDashboard/BussinessUnit";
import ListCategoryBusiness from "./components/pages/privateDashboard/businessDashboard/BusinessCategory";
import CreateBusinessUnit from "./components/pages/privateDashboard/businessDashboard/BussinessUnit/CreatedBusiness";
import CreateRevenueBusiness from "./components/pages/privateDashboard/businessDashboard/CreateRevenue";
import CreateValueBusiness from "./components/pages/privateDashboard/businessDashboard/CreateValueBusiness";
import CreateMoneyReport from "./components/pages/privateDashboard/businessDashboard/CreateMoneyReport";
import CreateCategory from "./components/pages/privateDashboard/businessDashboard/BusinessCategory/CreateCategory";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/connect-with-us" element={<ConnectWithUs />} />
        <Route path="/our-business" element={<OurWork />} />
        <Route path="/single-post" element={<SinglePost />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/careers" element={<Hiring />} />
        <Route path="/news" element={<News />} />
        <Route path="/services" element={<Services />} />
        <Route path="/login/investor" element={<InvestorLogin />} />
        <Route path="/login/business" element={<BusinessLogin />} />
        <Route path="/investor/dashboard" exact>
          <Route index element={<InvestorDashboard />} />
          <Route path="revenue-business" element={<RevenueBusiness />} />
          <Route path="total-business" element={<TotalBusiness />} />
          <Route path="value-business" element={<ValueBusiness />} />
          <Route path="report" element={<Report />} />
          <Route path="our-business" element={<OurBusiness />} />
        </Route>
        <Route path="/business/dashboard" exact>
          <Route index element={<BusinessDashboard />} />
          <Route path="revenue-business">
            <Route index element={<RevenueBusiness />} />
            <Route path="create" element={<CreateRevenueBusiness />} />
          </Route>
          <Route path="total-business">
            <Route index element={<TotalBusiness />} />
            <Route path="list" element={<ListBusiness />} />
            <Route path="create" element={<CreateBusinessUnit />} />
          </Route>
          <Route path='category-business'>
            <Route index element={<ListCategoryBusiness/>} />
            <Route path="create" element={<CreateCategory/>} />
          </Route>
          <Route path="value-business">
            <Route index element={<ValueBusiness />} />
            <Route path="create" element={<CreateValueBusiness />} />
          </Route>
          <Route path="report">
            <Route index element={<Report />} />
            <Route path="create" element={<CreateMoneyReport />} />
          </Route>
          <Route path="our-business" element={<OurBusiness />} />
        </Route>
        <Route path="/forbidden" element={<ForbiddenPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
